import { useEffect, useState } from 'react'
import { loadRoleConfigLookup } from '@/features/auth/services/rolesConfigApi'
import type { RoleConfigLookup } from '@/features/auth/types/utils'

const EMPTY_LOOKUP: RoleConfigLookup = {
  titleByRoleName: {},
  typeByRoleName: {},
}

/**
 * Loads GET /roles once (cached) for Angular `filter_user_roles` parity.
 */
export function useRoleConfigLookup(): RoleConfigLookup {
  const [lookup, setLookup] = useState<RoleConfigLookup>(EMPTY_LOOKUP)

  useEffect(() => {
    let cancelled = false

    loadRoleConfigLookup().then((result) => {
      if (!cancelled) setLookup(result)
    })

    return () => {
      cancelled = true
    }
  }, [])

  return lookup
}
